module.exports = __webpack_public_path__ + "1a979ea93cfcebe804d6e787b5bd4c05.MP3";